import { BoxContainerProps } from './box-container.props';

export const BoxContainerPresets: BoxContainerProps = {
  height: 'unset',
  margin: 'unset',
  maxWidth: '100vw',
  overflow: 'unset',
  padding: 'unset',
  width: 'unset',
};
